import React from 'react'
import { useNavigate } from "react-router-dom";
import { Stack, Badge, HStack, VStack, Button, Link} from '@chakra-ui/react'
import { useState } from 'react';
import classes from "./styles.module.css";


function LaporanPeserta ({
    idPeserta,
    idLaporan,
    bulan,
    minggu,
    waktuPost,
    status,
    topik,
    laporan,
    feedback}) {
        
    const navigate = useNavigate();
    const [lihatBalasan, setLihatBalasan] = useState(false)
    
    const handleLihatBalasan = () => {
        setLihatBalasan(!lihatBalasan);
        console.log(lihatBalasan)
    };

    bulan === 1 ? (bulan="Januari") : 
    bulan === 2 ? (bulan="Februari") : 
    bulan === 3 ? (bulan="Maret") :
    bulan === 4 ? (bulan="April") :
    bulan === 5 ? (bulan="Mei") :
    bulan === 6 ? (bulan="Juni") :
    bulan === 7 ? (bulan="Juli") :
    bulan === 8 ? (bulan="Agustus") :
    bulan === 9 ? (bulan="September") :
    bulan === 10 ? (bulan="Oktober") :
    bulan === 11 ? (bulan="November") : (bulan="Desember")

    return (
        <VStack marginBottom={6}>
            <VStack w='100%' align='stretch' justifyItems='left' spacing={2} border='2px' borderColor='gray.200' px={6} py={4}>
                <HStack justifyContent='left'  spacing={2} align='left'>
                {status === "Diterima" ? (
                    <Badge p={2} colorScheme='green' fontSize='10px' style={{display:'block'}}>{status}</Badge>
                    ) : (
                    status === "Ditolak" ? (
                        <Badge p={2} colorScheme='red' fontSize='10px' style={{display:'block'}}>{status}</Badge>
                    ) : (
                        <Badge p={2} colorScheme='purple' fontSize='10px' style={{display:'block'}}>{status}</Badge>
                ))}
                    <p style={{'color':'blueviolet', 'font-size': '14px','font-weight': '400', 'marginRight': '0', 'marginLeft': 'auto'}}>Posted . {waktuPost}</p>
                </HStack>
                { status === "Diterima" ? (
                    <HStack>
                    <p style={{'color':'darkgray', 'font-size': '14px','font-weight': '400'}}>{bulan}, Minggu ke-{minggu}</p>
                         <p style={{marginRight: '0', marginLeft: 'auto', 'color':'#6554C0', 'font-size': '14px','font-weight': '800'}}
                         >Feedback telah disetujui</p>
                     </HStack>
                )
                :
                (
                    <HStack>
                        <p style={{'color':'darkgray', 'font-size': '14px','font-weight': '400'}}>{bulan}, Minggu ke-{minggu}</p>
                        <Button style={{marginRight: '0', marginLeft: 'auto'}}
                            colorScheme='purple' variant='solid' fontSize='xs' height={8}
                            isDisabled={status==='Disetujui'}
                            onClick={() => navigate(`/peserta/kegiatanku/kegiatanaktif/editlaporan/${idPeserta}/${idLaporan}`)}>
                            Edit Laporan
                        </Button>
                    </HStack>
                )

                }
                
                <hr>
                </hr>
                <VStack align='stretch' spacing={2}>
                    <h3 className={classes.h} >Topik</h3>
                    <p className={classes.p}>{topik}</p>
                </VStack>
                <VStack align='stretch' spacing={2}>
                    <h3 className={classes.h} >Laporan</h3>
                    <p className={classes.p}>{laporan}</p>
                </VStack>
                <hr>
                </hr>
                <HStack>
                    <Link pt={2} style={{textDecoration: 'none', marginRight: '0', marginLeft: 'auto'}}
                        onClick={handleLihatBalasan}>
                        {feedback == null ? 
                        <p className={classes.h} >Menunggu Feedback</p> :
                        lihatBalasan === true ? 
                        <HStack style={{color:'#8a2be2'}}>
                            <p className={classes.h} >Tutup Feedback</p>
                            <i className='bx bx-chevron-up'></i>
                        </HStack>
                        :
                        <HStack style={{color:'#8a2be2'}}>
                            <p className={classes.h} >Lihat Feedback</p>
                            <i className={'bx bx-chevron-down'}></i>
                        </HStack>}
                    </Link>
                </HStack>
            </VStack>
            {feedback == null ? null :
            lihatBalasan === true ? (
                <Stack w='100%' pl={6} py={4}>
                <VStack align='stretch' justifyItems='left' pl={8} py={0} borderLeft='2px' borderColor='gray.300'>
                    <VStack align='stretch' px={6} py={6} border='2px' borderColor='gray.200' >
                        <h3 className={classes.h} >Feedback</h3>
                        <p className={classes.p}>{feedback}</p>
                    </VStack>
                </VStack>
                </Stack>
            ) : null}
        </VStack>
        )
    }

export default LaporanPeserta;